import { Buffer } from 'buffer';

import './main';
import './accordion';
import './bars';
import './brandslider';
import './circles';
import './cornerbars';
import './featuredbars';
import './industries';
import './stats';
import './testimonials';
import './testimonialnav';
import './navigation';
import './heading-section';


window.decryptEmail = function(encodedEmail) {
    var email = Buffer.from(encodedEmail, 'base64').toString('ascii');
    window.location.href = "mailto:" + email;
    return false;
}